import React, {
  forwardRef,
  InputHTMLAttributes,
} from "react";

interface InputProps extends InputHTMLAttributes<HTMLInputElement>{
   type: 'text' | 'password' | 'email' | 'number' | 'date';
}


export const Input = forwardRef<HTMLInputElement, InputProps >(

  ({ className='', ...props }, ref) => {
    return (
      <input
        ref={ref}
        className={`form-control form-control-lg form-control-solid input-field ${className}`}
        {...props}
      />
    );
  }
);
